import { type SxProps, type Theme } from '@mui/system';

export const style: SxProps<Theme> = {
  position: 'relative',
  flexGrow: '1',
  '& input': {
    height: '35px',
    border: '1px solid #006EC2',
    width: {
      xs: '100%',
      md: '280px',
    },
    outline: 'none !important',
    borderRadius: '3px',
    paddingRight: '35px',
  },
  '& .MuiSvgIcon-root': {
    position: 'absolute',
    right: '10px',
    top: '8px',
    fontSize: '18px',
  },
};
